export default ({ left, right }, context) => {
	const selectedVal = left.value ? right : left;
	return {
		type: selectedVal.type,
		value: selectedVal.value,
	};
};